// frontend/src/exercises/NonWords.js
import React, { useState, useContext, useEffect } from 'react';
import {getTranslation} from "../../config/translations";
import Header from "../../components/Header";
import StarBackground from "../../components/StarBackground";
import Character from "../../components/Character";
import Planet from "../../components/Planet";
import Controls from "../../components/Controls";
import {useNavigate} from "react-router-dom";
import config from './nonWordsConfig';


export default function NonWords() {
    const navigate = useNavigate();
    const [wordIndex, setWordIndex] = useState(0);
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('selectedLanguage') || 'it');
    const translations = getTranslation(currentLanguage);

    // Dynamically get words based on currentLanguage
    const words = translations.exerciseWords.nonWords[1] || [];

    const currentWord = words[wordIndex];
    const isLast = wordIndex === words.length - 1;

    const { enableText, enableAudio, setEnableText, setEnableAudio } = useContext(AppContext);

    const [isRecording, setIsRecording] = useState(false);

    const startRecording = () => {
        setIsRecording(true);
    };

    const stopRecording = () => {
        setIsRecording(false);
    };

    // Listen for language changes
    useEffect(() => {
        const handleLanguageChange = () => {
            const newLanguage = localStorage.getItem('selectedLanguage') || 'it';
            if (newLanguage !== currentLanguage) {
                setCurrentLanguage(newLanguage);
                // Reset wordIndex when language changes to start the exercise from the beginning for the new language
                setWordIndex(0);
            }
        };

        const interval = setInterval(handleLanguageChange, 500);

        return () => clearInterval(interval);
    }, [currentLanguage]);

    const handleValidate = () => {
        navigate('/exercise/nonWords/main/1');
    };

    return (
        <div style={{
            backgroundColor: config.backgroundColor,
            height: '100vh',
            overflow: 'hidden',
            position: 'relative',
            fontFamily: "'Autour One', cursive"
        }}>
            <Header
                color={config.headerColor}
                enableText={enableText}
                setEnableText={setEnableText}
                enableAudio={enableAudio}
                setEnableAudio={setEnableAudio}
            />
            <StarBackground imagePath={config.planetBackground} />
            <Character name="Mars" position='left' isActive={false} />
            <Character
                name={config.character}
                position='right'
                isActive={false}
            />
            <Planet image={config.planetImage} />

            {enableText && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    opacity: 0.9,
                    color: 'black',
                    padding: '1rem 2rem',
                    borderRadius: '12px',
                    fontSize: 'clamp(24px, 6vw, 48px)',
                    fontWeight: 'bold',
                    maxWidth: '90vw',
                    whiteSpace: 'nowrap'
                }}>
                    {currentWord}
                </div>
            )}
            <Controls
                colors={config.controlColors}
                onRepeat={() => console.log('Repeat')}
                onRecord={isRecording ? stopRecording : startRecording}
                onValidate={handleValidate}
                context={'1'} //Sostituire con test
                recording={isRecording}
                disableUpload={true}
            />
        </div>
    );
}
